import {
  OrderDetails,
  ScoresAndAddonProductsInformation,
  DemographicsInformation,
  InputFileInformation,
  OutputLocationsInformation,
  AttributesAndBundlesInformation,
  OutputLayoutInformation,
  AttributeLike,
  ReportsAttributeLike,
} from './products/ascend-quest';
import { InputLayoutField } from './fields';
import { ProgramDataType } from './program-data-type';
import { ProductNameEnum } from './product-package-names';
import { InputLayoutModel, MetadataInformation } from './products';
import { ApiResponse } from '../for-api';

export interface OutputLayoutFieldSources {
  scores?: string[];
  trendviewFields?: string[];
  demographics?: DemographicsInformation;
  inputFields?: InputLayoutField[];
  attributes?: AttributeLike[];
  reports?: ReportsAttributeLike;
  bundles?: string[];
}

export interface AscendArchivesOutputLayoutFieldSources
  extends OutputLayoutFieldSources {
  inputLayout?: InputLayoutModel[];
}

export interface SSARProgram {
  status: SSARProgramStatus;
  externalSystemRef?: string;
  subCode: string;
  programKey: string;
  orderDetails: OrderDetails;
  scoresAndAddonProducts: ScoresAndAddonProductsInformation;
  demographics: DemographicsInformation;
  inputFile: InputFileInformation;
  outputLocations: OutputLocationsInformation;
  attributesAndBundles: AttributesAndBundlesInformation;
  reports: ReportsAttributeLike;
  outputLayout: OutputLayoutInformation;
  version: 'v1';
  metadata?: MetadataInformation;
  dataDictionaryVersion?: string;
}

export enum SSARProgramStatus {
  Draft = 'Draft',
  Submitted = 'Submitted',
}

export enum ProgramSystemCode {
  SSAR = 'SSAR',
  // DraftSSAR = 'DraftSSAR',
}

export interface NewProgram {
  system: ProductNameEnum;
  programSchemaVersion: string;
  data: ProgramDataType;
  updatedAt: Date;
  submittedAt?: Date;
  submittedBy?: string;
  updatedBy: string;
  dataDictionaryVersion: string;
  programMetaId?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  externalSystemRef?: any;
}

export interface Program extends NewProgram {
  id: string;
}

export type InputFileUploadResponse = {
  fileName: string;
  originalFileName: string;
};

export type SubmitProgramApiResponse = ApiResponse<Pick<Program, 'id'>>;
// export type SSARProgramApiResponse = ApiResponse<SSARProgram>;
export type ProgramApiResponse = ApiResponse<Program>;
export type InputFileUploadApiResponse = ApiResponse<InputFileUploadResponse>;
